import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { Pharmacy } from '../../models/pharmacy';

@Injectable({
  providedIn: 'root',
})
export class PatientPharmaciesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientPharmaciesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientPharmacies`;

  getPatientPharmacies(patientId: number): Observable<Pharmacy[]> {
    const url = `${this.patientPharmaciesEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<Pharmacy[]>(url);
  }
}
